import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { downloadDocument } from 'aurora-composition/modules/common/actions';
import { ADGMGridLayoutV2, PanelHeaderActionButtons } from 'aurora-components';
import { DocumentsV2 } from 'aurora-section-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { REPRESENTATIVE_TYPES, SOURCE_OF_AUTHORIZATIONS } from '../constants';

import styles from './styles';

const RepresentativeSummary = ({
  classes,
  locale,
  isEditable,
  application,
  representative,
  party,
  documents,
  docsAttributes,
  editRepresentativeHandler,
  deleteRepresentativeHandler,
}) => {
  const dispatch = useDispatch();

  const getRepresentativeGridLayoutDetails = useCallback(
    repData => {
      return [
        {
          label: 'Name',
          value: locale === 'en' ? repData?.name || repData?.nameAr : repData?.nameAr || repData?.name,
          isPersonName: true,
        },
        {
          label: 'eid',
          value: repData?.eid,
        },
        {
          label: 'Nationality',
          value:
            locale === 'en'
              ? repData?.nationalityName || repData?.nationalityNameAr
              : repData?.nationalityNameAr || repData?.nationalityName,
        },
        {
          label: 'phone_number',
          value: <bdi>{repData?.phoneNo ?? '-'}</bdi>,
        },
        {
          label: 'email',
          value: repData?.email,
        },
        {
          label: 'poa_source_of_authorization',
          value: SOURCE_OF_AUTHORIZATIONS?.find(source => source?.value === repData?.source)?.label,
        },
        {
          label: 'representative_type',
          value: REPRESENTATIVE_TYPES?.find(repType => repType?.value === repData?.representativeType)?.label,
        },
        {
          label: 'authorization_no',
          value: repData?.poaNumber,
        },
        {
          label: 'authorization_date',
          value: repData?.authorizationDate ? moment(repData?.authorizationDate)?.format('DD/MM/YYYY') : '',
        },
      ];
    },
    [locale],
  );

  const downloadDocumentHandler = useCallback(
    params => {
      dispatch(downloadDocument(params));
    },
    [dispatch],
  );

  return (
    <div className={classes.container}>
      <div className={classNames(classes.representativeTitleAndActionsHolder, classes.containerPadding)}>
        <Typography className={classes.representativeTitle}>
          {keyEmptyCheck('representative_of', {
            s: locale === 'en' ? party?.name || party?.nameAr : party?.nameAr || party?.name,
          })}
        </Typography>
        {isEditable === true && (
          <PanelHeaderActionButtons
            editHandler={() => editRepresentativeHandler()}
            deleteHandler={() => deleteRepresentativeHandler({ representative, party })}
          />
        )}
      </div>
      <ADGMGridLayoutV2
        gridData={getRepresentativeGridLayoutDetails(representative)}
        withIcon
        customClasses={{ container: classes.representativeGridContainer }}
      />

      {!isEmpty(documents) && (
        <>
          <div className={classNames(classes.documentsHolder, classes.containerPadding)}>
            <DocumentsV2
              title='representative_documents'
              isPanel={false}
              isEditable={false}
              hideDownloadAllBtn
              handleDocDownload={downloadDocumentHandler}
              {...{
                lang: locale,
                applicationId: application?.applicationId,
                applicationType: application?.applicationType,
                documents,
                attributes: docsAttributes,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

RepresentativeSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  isEditable: PropTypes.bool.isRequired,
  application: PropTypes.object.isRequired,
  representative: PropTypes.object.isRequired,
  party: PropTypes.object.isRequired,
  documents: PropTypes.array.isRequired,
  docsAttributes: PropTypes.array.isRequired,
  editRepresentativeHandler: PropTypes.func.isRequired,
  deleteRepresentativeHandler: PropTypes.func.isRequired,
};

RepresentativeSummary.defaultProps = {};

export default withStyles(styles)(injectIntl(RepresentativeSummary));
